var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeyHighDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3450_1118)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 54,
    transform: "matrix(-1 0 0 1 108 2)",
    fill: "#313131",
    stroke: "#818181",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9372 71.4001C43.7639 71.4001 43.1772 71.0774 43.1772 70.4321V41.3921C43.1772 40.7467 43.7639 40.4241 44.9372 40.4241H45.2892C46.4626 40.4241 47.0492 40.7467 47.0492 41.3921V53.8441H62.9772V41.3921C62.9772 40.7467 63.5639 40.4241 64.7372 40.4241H65.0892C66.2626 40.4241 66.8492 40.7467 66.8492 41.3921V70.4321C66.8492 71.0774 66.2626 71.4001 65.0892 71.4001H64.7372C63.5639 71.4001 62.9772 71.0774 62.9772 70.4321V57.1881H47.0492V70.4321C47.0492 71.0774 46.4626 71.4001 45.2892 71.4001H44.9372Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3450_1118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyHighDefault);
export default __webpack_public_path__ + "static/media/key-high-default.a1183affc9765cff4295db0a60f05700.svg";
export { ForwardRef as ReactComponent };